<template>
  <title-tab 
    :msg="$t('title.prize')"
    :had-data="hadData"
  >
    <div class="search-btn">
      <v-menu
        top
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            class="icon-btn"
            v-on="on"
          >
            <v-icon class="search-icon">
              mdi-magnify
            </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in reorderedGames"
            :key="index"
            link
            @click="scrollToSection(item.id)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div class="mt-4">
      <n-datepicker-range 
        :range="false"  
        @setDateRange="setDateRange"
      >
      </n-datepicker-range>
    </div>

    <div
      v-for="game in yeekeeGames"
      :key="`yeekee-${game.id}`"
      class="mt-5"
    >
      <div class="game-type">
        <span class="py-1 mx-3 white--text ">{{ game.name }}</span>
      </div>

      <YeekeeColumn
        :game-rounds="lastGameResult(game)"
      ></YeekeeColumn>
    </div>

    <div
      v-for="game in reorderedGames"
      :key="game.id"
      class="mt-5"
    >
      <div class="game-type">
        <span class="py-1 mx-3 white--text ">{{ game.name }}</span>
      </div>

      <div :id="`section-` + game.id"></div>

      <OnlyFourNumber
        v-if="isCardOneColumn(game.id)"
        :game="game"
      ></OnlyFourNumber>
      <ThaiLotto
        v-else-if="isCardLotto(game.id)"
        :game="game"
      ></ThaiLotto>
      <ThreeColumn
        v-else-if="isCardThereColumn(game.id)"
        :game="game"
      ></ThreeColumn>
      <TwoColumn
        v-else
        :game="game"
      ></TwoColumn>
    </div>
  </title-tab>
</template>
<script>
import {
  IsYeekeeType,    
  CARD_ONE_COLUMN,
  CARD_TWO_COLUMN,
  CARD_FOUR_COLUMN
} from '@/const/gameId'
import ThaiLotto from '@/views-v2/Prize/childs/ThaiLotto'
import TwoColumn from '@/views-v2/Prize/childs/TwoColumn'
import YeekeeColumn from '@/views-v2/Prize/childs/YeekeeColumn'
import ThreeColumn from '@/views-v2/Prize/childs/ThreeColumn'
import OnlyFourNumber from '@/views-v2/Prize/childs/OnlyFourNumber'
import { st as apiSt, anonymous as apiAnonymous } from '@/apis'
import { FOREIGN_LOTTO, LOTTO } from '@/const/gameId'

export default {
  components:{ ThaiLotto, TwoColumn, YeekeeColumn, ThreeColumn, OnlyFourNumber },
  data: () => ({
    games: [],
    date: null,
    hadData: true
  }), 
  computed: {
    reorderedGames () {
      const others = this.games.filter(item => item.id !== 1);
      const target = this.games.find(item => item.id === 1);

      return target ? [...others, target] : others;
    },
    yeekeeGames () {
      return this.games.filter(item => item.id === 1);
    }
  },
  async created () {
    await this.load()
  },
  methods : {
    IsYeekeeType,
    setDateRange (event) {
      this.date = event
      this.load()
    },
    isCardTwoColumn (id) {
      return CARD_TWO_COLUMN.includes(id)
    },
    isCardFourColumn (id) {
      return CARD_FOUR_COLUMN.includes(id)
    },
    isCardOneColumn (id) {
      return CARD_ONE_COLUMN.includes(id)
    },
    isfiveColumnGame (item) {
      return item.win_number && item.four
    },
    isCardTwoColumnGame (item) {
      return item.two_down && item.three_up && !item.four
    },
    isCardOneColumnGame (item) {
      return item.four && !item.two_down
    },
    isThreePlusColumnGame (item) {
      return !item.win_number && item.four && item.two_down && item.three_up
    },
    isCardThereColumn (id) {
      return [FOREIGN_LOTTO].includes(id)
    },
    isCardLotto (id) {
      return [LOTTO].includes(id)
    },
    lastGameResult (game) {
      return game.game_rounds.filter(x => x.round_status.id == 106).slice(-3).reverse();
    },
    expand (){
      this.expandStatus = !this.expandStatus
      this.GA('expand','')
    },
    async load () {
      let params = {}

      if (this.date) {
        params.start_date = this.date[0]
        params.end_date = this.date[0]
      }

      this.hadData = false
      const [err,data] = await apiAnonymous.getLastWin(params)
      this.hadData = true  

      if(err) {
        return
      }

      this.games = data
    },

    async getResultGame (dateRange) { 
      //reset and load
      this.lotto=[]
      let type = IsYeekeeType(this.selectItem.game_type_id) ? 'last_round' : 'rounds'
     
      dateRange = dateRange ? dateRange : ['','']
      let params = {}
      if(IsYeekeeType(this.selectItem.game_type_id)) {
        params.game_type_id = this.selectItem.game_type_id
        params.start_date = dateRange[0]
        params.end_date = dateRange[0]
        if (dateRange[0] == '') {
          return
        }
      }
      if(this.selectItem.id && !IsYeekeeType(this.selectItem.game_type_id)) params.game_id = this.selectItem.id  
      this.hadData = false  
      const [err,data] = await apiSt.getWinNumber(params)
      this.hadData = true
      
      if(err || !data) {
        return
      }
      
      data.forEach(x=>{
        if(IsYeekeeType(this.selectItem.game_type_id)){
          ((x[type] || {}).round_rooms || []).forEach(xx=>{
            this.lotto.push(xx)
          })
        } else {
          x[type].forEach(y=>{
            (y || {}).round_rooms.forEach(yy=>{  
              if(yy.win_number){
                this.lotto.push(yy.win_number) 
              }
            })
          })
        }
      })
    },

    selectTypeGame (item) {
      this.GA('SelectTypeGame',item.name)

      //for mobile click and hide
      if(!this.$vuetify.breakpoint.mdAndUp){ 
        this.expandStatus = false
      }    
      //check current type is yeekee
      if(IsYeekeeType(item.game_type_id)){ 
        // check previous value of tab for reset date range 
        // if yeekee type reset date and it'll be automatic reload
        if(IsYeekeeType(this.selectItem.game_type_id)) {
          this.$refs.yeekeeprizeR.reSetDateRange()   
          this.selectItem = item
          return
        }
        //select item after check condition 
      }
      this.selectItem = item
      this.getResultGame()  
    },
    GA (action,value){
      this.$ga.event('Button', action, 'PrizePage',value ) 
    },

    scrollToSection (id) {
      const el = document.getElementById(`section-` + id)
      if (el) {
        const offset = 150 // px to leave at the top
        const top = el.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({ top, behavior: 'smooth' })
      }
    }
  } 
}
</script>
<style scoped>

.game-type {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: #606060;
  border-radius: 8px;
  font-size: 18px;
  background-color: var(--bg-secondary-color-v2);
}

.search-btn {
  position: fixed;
  bottom: 15%;
  right: 0;
  z-index: 1;
}

.icon-btn {
  background-color: var(--bg-main-color) !important;;
}

.search-icon {
  color: white !important;
}
</style>